var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"track-footer"},[_c('span',[_vm._v(_vm._s(_vm.$t("components.footer.poweredBy"))),_c('a',{staticClass:"textdecoration-underline",attrs:{"href":"https://nobordist.com/"}},[_vm._v("Nobordist")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }